import { render, staticRenderFns } from "./TemplateBlock.vue?vue&type=template&id=c37f9710&scoped=true"
import script from "./TemplateBlock.vue?vue&type=script&lang=js"
export * from "./TemplateBlock.vue?vue&type=script&lang=js"
import style0 from "./TemplateBlock.vue?vue&type=style&index=0&id=c37f9710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37f9710",
  null
  
)

export default component.exports